/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const HomeHealthPractitionerRole = {
    InitialReferring: 'INITIAL_REFERRING',
    F2FEncounter: 'F2F_ENCOUNTER',
    F2FCertifying: 'F2F_CERTIFYING',
    PlanOfCareSigning: 'PLAN_OF_CARE_SIGNING'
} as const;
export type HomeHealthPractitionerRole = typeof HomeHealthPractitionerRole[keyof typeof HomeHealthPractitionerRole];


export function HomeHealthPractitionerRoleFromJSON(json: any): HomeHealthPractitionerRole {
    return HomeHealthPractitionerRoleFromJSONTyped(json, false);
}

export function HomeHealthPractitionerRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthPractitionerRole {
    return json as HomeHealthPractitionerRole;
}

export function HomeHealthPractitionerRoleToJSON(value?: HomeHealthPractitionerRole | null): any {
    return value as any;
}
